package api.dataclasses.deliveries

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Delivery(
    @SerialName("RecordId") val recordId: Int,
    @SerialName("Eigenaar") val owner: String,
    @SerialName("Opdrachtnummer") val orderNumber: String,
    @SerialName("Referentie(s)") val references: String?,
    @SerialName("Statusomschrijving") val statusDescription: String,
    @SerialName("Totaal_verwacht") val totalExpected: String,
    @SerialName("Totaal_ontvangen") val totalReceived: String,
    @SerialName("Verwachte datum") val expectedDate: String,
    @SerialName("Verwerkingsdatum") val processingDate: String?
)
